
export const enel = require('./images/enel.png');
export const plenitude = require('./images/plenitude.png');
export const illumia = require('./images/illumia.jpeg');
export const union = require('./images/union.png');
export const logo = require('./images/logo.png');

